import React from 'react';
import { motion } from 'framer-motion';
import SlotCounter from 'react-slot-counter';
import {Helmet} from '@dr.pogodin/react-helmet';

const ContactsPage = () => {
    return (
        <>
            <Helmet>
                <title>Contact Me - Lesia K Slot 2D Art Development</title>
                <link rel="canonical" href={`https://lesia-k.com/contact`}/>

                <meta name="description"
                      content="Get in touch with Lesia K for inquiries about 2D art development services for slot games. Reach out via email or connect on LinkedIn to discuss your project needs."/>
                <meta name="keywords"
                      content="contact Lesia K, 2D art inquiries, slot game art contact, Lesia K email, connect with Lesia K"/>
                <meta property="og:title" content="Contact Me - Lesia K Slot 2D Art Development"/>
                <meta property="og:description"
                      content="Get in touch with Lesia K for inquiries about 2D art development services for slot games. Reach out via email or connect on LinkedIn to discuss your project needs."/>
                <meta property="og:url" content="https://lesia-k.com/contact"/>
                <meta name="twitter:title" content="Contact Me - Lesia K Slot 2D Art Development"/>
                <meta name="twitter:description"
                      content="Get in touch with Lesia K for inquiries about 2D art development services for slot games. Reach out via email or connect on LinkedIn to discuss your project needs."/>
            </Helmet>
            <section className="min-h-screen w-screen relative mt-10">

                <div className="flex flex-col items-center justify-center h-full px-6 text-center">
                    <div className="min-h-1/2">
                        <motion.h1
                            className="text-6xl lg:text-8xl font-bold text-white font-boldonse mb-8"
                            initial={{opacity: 0, y: -50}}
                            animate={{opacity: 1, y: 0}}
                            transition={{duration: 0.8}}
                        >
                            <SlotCounter
                                dummyCharacters={'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').map(char => (
                                    <span key={char}>{char}</span>))}
                                duration={2}
                                value={[
                                    <span className="bg-gray-300 p-5"><span
                                        className="bg-pink-700 text-transparent bg-clip-text">C</span></span>,
                                    <span className="bg-pink-700 text-transparent bg-clip-text">o</span>,
                                    <span className="bg-pink-700 text-transparent bg-clip-text">n</span>,
                                    <span className="bg-pink-700 text-transparent bg-clip-text">t</span>,
                                    <span className="bg-pink-700 text-transparent bg-clip-text">a</span>,
                                    <span className="bg-pink-700 text-transparent bg-clip-text">c</span>,
                                    <span className="bg-pink-700 text-transparent bg-clip-text">t</span>,
                                ]}
                            /><br/>
                            <SlotCounter
                                dummyCharacters={'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').map(char => (
                                    <span key={char}>{char}</span>))}
                                duration={2}
                                value={[
                                    <span className="bg-gray-300 p-5"><span
                                        className="bg-pink-700 text-transparent bg-clip-text">M</span></span>,
                                    <span className="bg-pink-700 text-transparent bg-clip-text">e</span>,
                                ]}
                            />
                        </motion.h1>

                        <div className="bg-white rounded-lg shadow-md p-8 w-full max-w-md mx-auto">
                            <h2 className="text-2xl font-semibold mb-6">Get in Touch</h2>

                            <div className="mt-8">
                                <h3 className="text-lg font-semibold mb-2">My Email</h3>
                                <p>
                                    <a href="mailto:lesia_khvorostina@yahoo.com">lesia_khvorostina@yahoo.com</a>
                                </p>

                                <h3 className="text-lg font-semibold mb-2 mt-4">Follow Me</h3>
                                <p>
                                    <a href="https://www.linkedin.com/in/lesia-k-93856a16/" target="_blank"
                                       rel="noopener noreferrer"
                                       className="text-pink-600 hover:underline flex gap-2 justify-center items-center">
                                        <img
                                            className={"w-4 h-4 inline-block ms-2 invert"}
                                            alt="LinkedIn"
                                            src={"/assets/linkedin.svg"}
                                        />
                                        LinkedIn Profile
                                    </a>
                                </p>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ContactsPage;
